import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import PeladaDetalhes from "./pages/PeladaDetails";
import AdminPelada from "./pages/AdminPelada";
import EditarDados from "./pages/EditarDados";
import AuthWrapper from "./AuthWrapper";
import InstallPopup from "./components/InstallPopup"; // Importa o popup de instalação

const App = () => {
  return (
    <Router>
      <div>
        {/* Popup de instalação */}
        <InstallPopup />

        {/* Rotas da aplicação */}
        <Routes>
          {/* Rota de login */}
          <Route path="/login" element={<Login />} />

          {/* Rotas protegidas pelo AuthWrapper */}
          <Route
            path="*"
            element={
              <AuthWrapper>
                <Routes>
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/peladas/:peladaId" element={<PeladaDetalhes />} />
                  <Route path="/admin/:peladaId" element={<AdminPelada />} />
                  <Route path="/editar-dados" element={<EditarDados />} />
                  <Route path="*" element={<Navigate to="/dashboard" />} /> {/* Redireciona para o dashboard caso a rota não exista */}
                </Routes>
              </AuthWrapper>
            }
          />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
